import React, { useMemo, useState, useRef, useCallback } from 'react'

// Helpers
import { Formaters } from '../../../../helpers'

// Components
import { Modal, Table } from '../../../../components'

// SubComponents
import { Menu } from './menu'
import { Filter } from './filter'
import { LessonModal } from './modal'

// Styles
import { Container, Content } from './styles'

export const LessonsTable = ({ data, loading }) => {
  // Hooks
  const modalRef = useRef(null)
  const [filter, setFilter] = useState('')
  const [editData, setEditData] = useState(null)
  const [select, setSelect] = useState({
    value: 'title',
    label: 'Título'
  })
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false)

  const filteredItems = useCallback(() => {
    if (select.value === 'title')
      return data.filter(
        item =>
          item.content &&
          item.content[select.value] &&
          item.content[select.value]
            .toLowerCase()
            .includes(filter.toLowerCase())
      )
    else
      return data.filter(
        item =>
          item[select.value] &&
          item[select.value].toLowerCase().includes(filter.toLowerCase())
      )
  }, [data, filter, select])

  // Uses
  const handleOpenModal = useCallback(data => {
    if (data) setEditData(data)
    else setEditData(null)

    modalRef.current.toggleModal()
  }, [])

  const HeaderMemo = useMemo(() => {
    const handleClear = () => {
      if (filter) {
        setResetPaginationToggle(!resetPaginationToggle)
        setFilter('')
      }
    }

    return (
      <Filter
        selectData={[{ value: 'content.title', label: 'Título' }]}
        onSelect={e => setSelect(e)}
        onFilter={e => setFilter(e.target.value)}
        onClear={handleClear}
        filter={filter}
        onModal={handleOpenModal}
      />
    )
  }, [filter, resetPaginationToggle, handleOpenModal])

  return (
    <Container>
      <Content>
        <h1>Aulas</h1>
        {HeaderMemo}
      </Content>
      <Table
        columns={[
          { name: 'Título', selector: 'content.title', sortable: true },
          { name: 'Slug', selector: 'content.slug', sortable: true },
          { name: 'Ordem', selector: 'content.order', sortable: true },
          { name: 'Tipo', selector: 'type', sortable: true },
          {
            name: 'Conteúdo',
            selector: 'content.resource',
            sortable: true,
            grow: 3
          },
          {
            name: 'Anexos',
            selector: 'content.attachments',
            sortable: true,
            grow: 3
          },
          { name: 'Plataforma', selector: 'content.platform', sortable: true },
          {
            name: 'Data de Criação',
            selector: 'created_at',
            sortable: true,
            format: row => Formaters.date(row.created_at)
          },
          {
            name: 'Data de Atualização',
            selector: 'updated_at',
            sortable: true,
            format: row => Formaters.date(row.updated_at)
          },
          {
            cell: row => (
              <Menu row={row} onModal={data => handleOpenModal(data)} />
            )
          }
        ]}
        data={filteredItems()}
        paginationResetDefaultPage={resetPaginationToggle}
        persistTableHead
        progressPending={loading}
      />
      <Modal ref={modalRef}>
        <LessonModal data={editData} />
      </Modal>
    </Container>
  )
}
